/**
 * Describe the state of the preview images
 */
export let PreviewState;

(function (PreviewState) {
  PreviewState[PreviewState["Available"] = 1] = "Available";
  PreviewState[PreviewState["Empty"] = 0] = "Empty";
  PreviewState[PreviewState["Loading"] = -1] = "Loading";
  PreviewState[PreviewState["ExtensionFailure"] = -2] = "ExtensionFailure";
  PreviewState[PreviewState["UploadFailure"] = -3] = "UploadFailure";
  PreviewState[PreviewState["Postponed"] = -4] = "Postponed";
  PreviewState[PreviewState["NoPreviewProviderEnabled"] = -5] = "NoPreviewProviderEnabled";
  PreviewState[PreviewState["ClientFailure"] = -665] = "ClientFailure";
})(PreviewState || (PreviewState = {}));
//# sourceMappingURL=enums.js.map